/**
 * App router — wraps route configuration with Suspense
 * for lazy-loaded routes, a global error boundary, and
 * automatic route tracking.
 */

import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from '@/app/routes';
import { ErrorBoundary, SuspenseFallback, RouteTracker } from '@/components/shared';

const router = createBrowserRouter([
  {
    element: <RouteTracker />,
    children: routes,
  },
]);

export function AppRouter(): JSX.Element {
  return (
    <ErrorBoundary>
      <Suspense fallback={<SuspenseFallback />}>
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  );
}
